import { useCallback } from "react";
import { useTheme } from "styled-components";
import { FeeCode, getFeeCode } from "utils/fees";

const useFeeColor = () => {
  const theme = useTheme();

  const getFeeColor = useCallback(
    (fee: string) =>
      getFeeCode(fee)
        ? theme.colors.fee[getFeeCode(fee) as FeeCode]
        : theme.colors.text.secondary,
    [theme],
  );

  return { getFeeColor };
};

export default useFeeColor;
